import { render, staticRenderFns } from "./NewPasswordView.vue?vue&type=template&id=18540816&"
import script from "./NewPasswordView.vue?vue&type=script&lang=ts&"
export * from "./NewPasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports